var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eGhaJjprqD11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,12c0-4.97056-4.0294-9-9-9s-9,4.02944-9,9s4.02944,9,9,9s9-4.0294,9-9Zm-2,0c0-3.86599-3.134-7-7-7s-7,3.13401-7,7s3.13401,7,7,7s7-3.134,7-7Z",
    opacity: 0.1,
    clipRule: "evenodd",
    fill: "#333",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eGhaJjprqD13_tr",
    transform: "translate(12,12) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12,-12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,12c0-4.97056-4.0294-9-9-9s-9,4.02944-9,9s4.02944,9,9,9s9-4.0294,9-9Zm-2,0c0-3.86599-3.134-7-7-7s-7,3.13401-7,7s3.13401,7,7,7s7-3.134,7-7Z",
    opacity: 0,
    clipRule: "evenodd",
    fill: "#FAD200",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4442,3.68508C14.3522,3.23279,13.1819,3,12,3v2c1.933,0,3.683.7835,4.9497,2.05025L18.364,5.63604c-.8358-.83573-1.8279-1.49866-2.9198-1.95096Z",
    clipRule: "evenodd",
    fill: "#FAD200",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.3ae18770.svg";
export { ForwardRef as ReactComponent };